export default __webpack_public_path__ + "static/media/open-ai.44ecb7ba.svg";